import { render, staticRenderFns } from "./RrcvE_Receive.vue?vue&type=template&id=027a35fb"
import script from "./RrcvE_Receive.vue?vue&type=script&lang=js"
export * from "./RrcvE_Receive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports